import { render, staticRenderFns } from "./xsftjllist.vue?vue&type=template&id=856752fe&scoped=true"
import script from "./xsftjllist.vue?vue&type=script&lang=js"
export * from "./xsftjllist.vue?vue&type=script&lang=js"
import style0 from "./xsftjllist.vue?vue&type=style&index=0&id=856752fe&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856752fe",
  null
  
)

export default component.exports